import React from "react";

interface CheckboxProps {
  name: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: React.ReactElement;
  className?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  checked,
  onChange,
  label,
  className = "",
  disabled = false,
}) => {
  return (
    <label
      className={`flex items-center gap-3 text-sm rounded px-3 py-2 cursor-pointer transition ${className} ${
        disabled
          ? "text-gray-500 cursor-not-allowed"
          : checked
          ? "bg-yellow-900/20 border border-yellow-400 text-yellow-100"
          : "hover:bg-gray-700 text-gray-200 border border-gray-600"
      }`}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`w-4 h-4 text-sm rounded-sm cursor-pointer transition-all focus:ring-0 ${
          checked ? "bg-yellow-400 border-yellow-400" : "bg-gray-300 border-gray-400"
        }`}
      />
      {label && <span>{label}</span>}
    </label>
  );
};

export default Checkbox;
